import { COMPANY_EMAIL } from "../constants/urls";

// 개인정보 처리방침 (Privacy Policy)
export const POLICY_2_CONTENT = `
<p>주식회사 브레인다이브(이하 "회사"라 합니다)은 이용자(정보주체)의 개인정보를 보호하고 이와 관련된 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립 · 공개합니다.</p>

<h2>제 1 조 [개인정보의 수집·처리목적]</h2>
<p>회사는 다음 각 호의 목적으로 이용자의 개인정보를 수집·처리합니다. 수집·처리하는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.</p>
<p class="indent">1. 홈페이지 회원 가입 및 관리: 회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 이용약관 위반 회원에 대한 이용제한 조치, 가입 및 가입횟수 제한, 서비스 부정 이용 방지 및 제재, 비인가 사용 방지, 각종 고지 및 통지, 고충 처리 및 분쟁 조정을 위한 기록 보존, 회원탈퇴 의사의 확인 목적으로 개인정보를 수집·처리합니다.</p>
<p class="indent">2. 서비스 제공 및 신규 서비스 개발: 신규 서비스 개발 및 맞춤 서비스 제공, 서비스의 유효성 확인, 이벤트 · 광고성 정보 및 참여 기회 제공, 접속빈도 파악, 회원의 서비스 이용에 대한 통계, 계약서·청구서 발송, 대금 결제·정산, 본인 인증, 연령 인증, 만 14세 미만 아동 정보수집 방지, 부정 이용 방지 목적으로 개인정보를 수집·처리합니다. 위 목적은 회사가 직접 수집·처리하는 회원 개인정보 및 서비스 이용 기록에 한하여 적용되며, 학교 또는 수행기관으로부터 위탁받아 처리하는 학생 개인정보에는 적용되지 않습니다.</p>
<p class="indent">3. 고충처리: 민원인 신원 확인, 민원사항 확인, 사실조사를 위한 연락 · 통지, 처리결과 통보 목적으로 개인정보를 수집·처리합니다.</p>
<p class="indent">4. 보건업무 행정 지원 서비스 제공: 회사는 학교 또는 수행기관의 보건업무 행정 지원을 위하여, 해당 학교 또는 수행기관이 개인정보처리자로서 적법하게 수집·보유하는 학생, 교직원 또는 기타 처치 대상자의 개인정보를 개인정보 처리위탁에 따라 위탁받아 처리합니다. 회사는 위탁받은 개인정보를 건강관리, 보건기록 관리, 통계 작성, 행정 보고, 문서 작성 지원 등 위탁 목적 범위 내에서만 처리하며, 그 외의 용도로는 이용하지 않습니다.</p>

<h2>제 2 조 [수집·처리하는 개인정보의 항목]</h2>
<p>1. 회사는 다음 각 호의 개인정보를 수집·처리하고 있습니다.</p>
<p class="indent">① 홈페이지 회원가입 및 관리</p>
<p class="indent2">– (필수항목) 성명, 직책, 소속, 학교명, 학교의 주소, 연락 가능한 번호, E-mail, ID, 비밀번호, 학교의 사업자번호</p>
<p class="indent2">– (선택항목) 추천인ID, 추천인 전화번호(알림톡 발송용)</p>
<p class="indent">② 서비스의 제공 및 신규 서비스 개발</p>
<p class="indent2">– (필수항목) 방문일시, IP주소, 쿠키 등 서비스 이용 기록 및 기기정보</p>
<p>2. 회사는 원칙적으로 만 14세 미만 아동의 개인정보를 직접 수집하지 않습니다. 다만, 학교(교육기관)가 개인정보처리자로서 적법하게 수집한 학생의 개인정보를 보건업무 행정 지원 목적에 한하여 수집·처리할 수 있습니다.</p>
<div style="display: flex; gap: 10px; margin: 16px 0; justify-content: space-between;">
<img src="/images/privacy1.png" alt="privacy 1" style="width: 32%; object-fit: contain;" />
<img src="/images/privacy2.png" alt="privacy 2" style="width: 32%; object-fit: contain;" />
<img src="/images/privacy3.png" alt="privacy 3" style="width: 32%; object-fit: contain;" />
</div>
<p>3. 학교 위탁 보건업무 행정 지원 서비스 이용 과정에서 학교 또는 수행기관으로부터 위탁받아 처리하는 학생 정보</p>
<p class="indent">– 필수항목: 학년, 반, 번호, 성별, 이름</p>
<p class="indent">– 선택항목: 건강상태 관련 정보(예: 시력, 키·몸무게, 질병 유무, 보건실 이용 기록 등)</p>
<p class="indent">※ 위 정보는 학교 또는 수행기관이 적법하게 수집·보유하는 정보에 한하여 회사가 위탁받아 처리합니다.</p>

<h2>제 3 조 [개인정보 수집방법]</h2>
<p>회사는 다음 각 호의 방법으로 개인정보를 처리합니다.</p>
<p class="indent">1. 회원가입, 서비스 이용, 고객센터 문의, 계약 체결 및 결제 과정에서 이용자가 직접 입력하거나 제공하는 정보</p>
<p class="indent">2. 서비스 이용 과정에서 자동으로 생성·수집되는 접속기록, 쿠키, 기기정보 등</p>
<p class="indent">3. 회사가 진행하는 이벤트·행사 참여 과정에서 이용자가 제공하는 정보</p>
<p class="indent">4. 외부 제휴사 또는 협력기관으로부터 적법한 절차에 따라 제공받는 정보</p>
<p class="indent">5. 학교, 교육청 등 공공·교육기관 또는 보건교사가 보건업무 수행을 위하여 회사에 개인정보 처리업무를 위탁하는 경우, 해당 기관이 적법하게 수집·보유하는 학생, 교직원 또는 기타 처치 대상자 정보</p>
<p>회사는 회사가 직접 수집하는 회원 개인정보에 대하여는 관계 법령에 따라 필요한 경우 사전 고지 및 동의를 받으며, 학교 또는 수행기관으로부터 위탁받아 처리하는 개인정보는 해당 기관의 적법한 수집 및 처리 근거에 따라 위탁 범위 내에서 처리합니다.</p>

<h2>제 4 조 [개인정보 자동수집 장치의 설치 · 운영 및 거부]</h2>
<p>회사는 이용자에게 특화된 맞춤서비스를 제공하기 위해서 이용자들의 정보를 수시로 저장하고 수시로 찾아내는(불러내는) '세션(session)' 또는 '쿠키(cookie)' 등을 설치·운영합니다.</p>
<p class="indent">1. 세션 및 쿠키의 의미: '세션'이란 회사가 서비스를 제공하는데 이용되는 서버가 이용자의 접속시간 동안 이용정보를 서버에 저장하는 것을 의미하고, '쿠키'란 웹사이트를 운영하는 데 이용되는 서버가 이용자의 브라우저에 보내는 작은 텍스트 파일로서 이용자의 컴퓨터 하드디스크에 저장되기도 하는 정보를 말합니다.</p>
<p class="indent">2. 세션 및 쿠키의 사용 목적: 회사는 회원 및 방문자의 접속 빈도, 방문 시간, 서비스 이용 패턴 등을 분석하여 서비스 개선, 이용 편의 향상, 맞춤형 화면 제공, 이벤트 운영 및 마케팅 효율성 분석을 위하여 세션 및 쿠키를 사용할 수 있습니다.</p>
<p class="indent">다만, 이러한 자동수집 장치는 회사가 직접 수집·처리하는 회원 또는 방문자 정보에 대하여만 적용되며, 학교 또는 수행기관으로부터 위탁받아 처리하는 학생 개인정보를 마케팅 또는 광고 목적으로 분석하는 데에는 사용되지 않습니다.</p>
<p class="indent">3. 세션 및 쿠키의 설정 거부 방법: 이용자는 세션의 설치 및 설정에 대한 선택권을 갖지 않으나, 쿠키 설치 여부에 대한 선택권을 가지고 있습니다. 따라서 이용자는 웹 브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수도 있습니다. 단, 쿠키 설치를 거부하는 경우 이용자 개인 맞춤형 서비스 이용에 어려움이 발생할 수 있습니다.</p>
<p class="indent2">인터넷 익스플로러 – 웹 브라우저 상단의 [도구]&gt;[인터넷 옵션]&gt;[개인정보]&gt;[고급] 메뉴를 통하여 쿠키 설정을 거부할 수 있습니다.</p>
<p class="indent2">Safari – MacOS 상단 좌측 메뉴바에서 [Safari]&gt;[환경설정]&gt;[보안]을 통하여 쿠키 허용 여부를 선택할 수 있습니다.</p>

<h2>제 5 조 [개인정보의 제3자 제공]</h2>
<p>① 회사는 이용자의 개인정보를 제1조에서 명시한 목적 범위 내에서만 처리하며, 이용자의 동의 또는 법령의 특별한 규정이 있는 경우에만 제3자에게 개인정보를 제공합니다.</p>
<p>② 회사는 서비스 제공을 위하여 필요한 범위 내에서 이용자의 동의를 얻는 등 적법한 절차에 따라 아래와 같이 개인정보를 제3자에게 제공할 수 있습니다.</p>
<p>③ 회사는 보건업무 행정 지원 서비스와 관련하여 처리되는 학생의 개인정보를 어떠한 경우에도 제3자에게 제공하지 않으며, 법령에 근거하거나 학교(개인정보처리자)의 명시적 요청이 있는 경우에 한하여 최소한의 범위에서만 제공합니다.</p>

<h2>제 6 조 [개인정보 처리위탁에 관한 사항]</h2>
<p>회사는 보건업무 행정 지원 서비스 제공을 위하여 학교 또는 교육기관으로부터 개인정보 처리업무를 위탁받아 수행합니다.</p>
<p>① 위탁받는 업무의 내용</p>
<p class="indent">– 학생 보건 관련 정보의 전산 처리 및 관리</p>
<p class="indent">– 보건업무 관련 통계 산출 및 행정 문서 작성 지원</p>
<p>② 회사는 위탁계약 체결 시 「개인정보 보호법」 제26조에 따라 다음 사항을 준수합니다.</p>
<p class="indent">– 개인정보의 목적 외 이용 금지</p>
<p class="indent">– 기술적·관리적 보호조치</p>
<p class="indent">– 재위탁 제한</p>
<p class="indent">– 관리·감독 및 손해배상 책임에 관한 사항</p>

<h2>제 7 조 [개인정보 처리 및 보유기간]</h2>
<p>① 회사는 법령에 따른 개인정보 보유·이용기간 또는 이용자로부터 개인정보 수집 시 동의 받은 개인정보 보유 · 이용 기간내에서 개인정보를 처리 · 보유합니다. 회사는 이용자가 입력한 정보 중 회사의 서비스 제공 과정에서 부정확한 것으로 확인된 정보에 대해서는 제3자의 권리와 이익의 침해를 방지하고 정보의 최신성을 유지하기 위하여 해당 정보를 즉시 파기할 수 있습니다.</p>
<p>② 각각의 개인정보 처리 및 보유기간은 다음과 같습니다.</p>
<p class="indent">1. 홈페이지 회원가입 및 관리: 회원 탈퇴 시까지. 단, 다음의 사유에 해당하는 경우에는 그 해당사유의 종료 시까지</p>
<p class="indent2">가. 관계 법령 위반에 따른 수사 · 조사 등이 진행 중인 경우에는 해당 수사 · 조사 종료 시까지</p>
<p class="indent2">나. 서비스 이용에 따른 채권 · 채무관계가 잔존하는 경우에는 해당 채권 · 채무관계의 정산 시까지</p>
<p class="indent">2. 서비스 제공 및 신규 서비스 개발: 서비스 제공 완료 및 대금의 결제·정산 완료 시까지. 단, 다음의 사유에 해당하는 경우에는 그 해당 기간의 종료 시까지</p>
<p class="indent2">가. 「전자상거래 등에서의 소비자 보호에 관한 법률」에 따른 표시 · 광고, 계약내용 및 이행 등 거래에 관한 기록</p>
<p class="indent2">– 표시 · 광고에 관한 기록: 6개월</p>
<p class="indent2">– 계약 또는 청약철회, 대금결제, 서비스 등의 제공에 관한 기록: 5년</p>
<p class="indent2">– 소비자 불만 또는 분쟁처리에 관한 기록: 3년</p>
<p class="indent2">나. 「통신비밀보호법」에 따른 통신사실확인자료 보관</p>
<p class="indent2">– 가입자 전기통신일시, 개시 · 종료 시간, 상대방 가입자번호, 사용 도수, 발신기지국 위치추적자료: 1년</p>
<p class="indent2">– 컴퓨터 통신, 인터넷 로그기록자료, 접속지 추적 자료: 3개월</p>
<p>③ 회사는 '개인정보 유효기간제'에 따라 1년간 서비스를 이용하지 않은 이용자의 개인정보를 별도로 분리보관 또는 삭제합니다.</p>
<p>④ 학생 개인정보는 학교 또는 보건교사의 위탁 목적이 종료되거나 위탁계약이 종료되는 즉시 지체 없이 파기합니다. 단, 법령에 따라 보관이 필요한 경우에는 해당 법령에서 정한 기간 동안만 보관합니다.</p>

<h2>제 8 조 [개인정보의 파기 절차 및 방법]</h2>
<p>① 회사는 개인정보 보유기간의 경과, 처리목적의 달성 등 개인정보가 불필요하게 되었을 때에는 지체 없이 해당 개인정보를 파기합니다.</p>
<p>② 이용자로부터 동의를 받은 개인정보는 보유기간이 경과하거나 수집 목적이 달성되었음에도 불구하고 다른 법령에 따라 보관하는 경우에는, 해당 개인정보를 별도의 데이터베이스로 옮기거나 보관장소를 달리하여 보존합니다.</p>

<table>
<thead>
<tr><th>보존 항목</th><th>근거법령</th><th>보존기간</th></tr>
</thead>
<tbody>
<tr><td>계약 또는 청약철회 등에 관한 기록</td><td rowspan="4">전자상거래 등에서의 소비자 보호에 관한 법률</td><td>5년</td></tr>
<tr><td>대금결제 및 서비스 등의 공급에 관한 기록</td><td>5년</td></tr>
<tr><td>소비자의 불만 또는 분쟁처리에 관한 기록</td><td>3년</td></tr>
<tr><td>표시·광고에 관한 기록</td><td>6개월</td></tr>
<tr><td>세법이 규정하는 모든 거래에 관한 장부 및 증빙서류</td><td>국세기본법</td><td>5년</td></tr>
<tr><td>전자금융거래에 관한 기록</td><td>전자금융거래법</td><td>5년</td></tr>
<tr><td>서비스 방문 기록</td><td>통신비밀보호법</td><td>3개월</td></tr>
</tbody>
</table>

<p>③ 개인정보의 파기 절차 및 방법은 다음 각 호와 같습니다.</p>
<p class="indent">1. 파기절차: 회사는 파기 사유가 발생한 개인정보를 선정하고, 회사의 개인정보 보호책임자의 승인을 받아 해당 개인정보를 파기합니다.</p>
<p class="indent">2. 파기방법: 회사는 다음 각 목의 방법으로 개인정보를 파기합니다.</p>
<p class="indent2">가. 종이에 기록, 저장된 개인정보: 분쇄기로 분쇄하거나 소각하여 파기</p>
<p class="indent2">나. 전자적 파일 형태로 저장된 개인정보: 기록을 재생할 수 없도록 기술적 방법을 사용하여 파기</p>

<h2>제 9 조 [이용자의 권리 · 의무 및 행사방법]</h2>
<p>① 이용자는 회사에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.</p>
<p class="indent">1. 개인정보 열람 및 정정 요구</p>
<p class="indent2">가. 이용자는 언제든지 등록되어 있는 본인의 개인정보를 열람하거나 정정할 수 있습니다.</p>
<p class="indent2">나. 개인정보 열람 및 정정을 하고자 할 경우에는 '설정&gt; 회원정보 수정'을 클릭하여 직접 열람 또는 정정하거나, 서면, 전화(010-3076-4308), 전자우편(yeongjin.yoo.dev@gmail.com) 등을 통하여 요청하시면 본인확인 절차를 거쳐 지체 없이 조치합니다.</p>
<p class="indent2">다. 회사는 이용자로부터 개인정보 열람 또는 정정의 요구가 있는 경우 법정 기한 내에 그 요구에 응답합니다. 단, 해당 기간 내에 응답할 수 없는 정당한 사유가 있을 때에는 이용자에게 그 사유를 알리고 연기할 수 있으며, 그 사유가 소멸하면 지체 없이 응답합니다.</p>
<p class="indent">2. 개인정보의 수집 등에 대한 동의 철회, 삭제 및 처리정지</p>
<p class="indent2">가. 이용자는 회원가입 등을 통해 개인정보의 수집, 이용, 제공 등 처리에 대해 동의한 내용을 언제든지 철회하거나, 삭제 및 처리정지를 요청할 수 있습니다.</p>
<p class="indent2">나. 동의 철회, 삭제 및 처리정지를 하고자 할 경우에는 홈페이지 내 고객센터 연락, 전자우편 등을 통하여 요청하시면 본인확인 절차를 거쳐 지체 없이 조치합니다.</p>
<p>② 회사는 다음 각 호와 같은 사유로 개인정보 열람 또는 처리정지를 제한하거나 거절할 수 있으며, 이용자에게 그 사유를 지체 없이 알리고 있습니다.</p>
<p class="indent">1. 개인정보 열람 제한/거절 사유</p>
<p class="indent2">가. 법률에 따라 열람 등이 금지되거나 제한되는 경우</p>
<p class="indent2">나. 다른 사람의 생명, 신체를 해할 우려가 있거나 다른 사람의 재산과 그 밖의 이익을 부당하게 침해할 우려가 있는 경우</p>
<p class="indent">2. 개인정보 처리정지 거절 사유</p>
<p class="indent2">가. 법률에 특별한 규정이 있거나 법령상 의무를 준수하기 위하여 불가피한 경우</p>
<p class="indent2">나. 다른 사람의 생명·신체를 해할 우려가 있거나 다른 사람의 재산과 그 밖의 이익을 부당하게 침해할 우려가 있는 경우</p>
<p class="indent2">다. 개인정보를 처리하지 아니하면 이용자와 약정한 서비스를 제공하지 못하는 등 계약의 이행에 곤란한 경우로서 이용자가 그 계약의 해지 의사를 명확하게 밝히지 아니한 경우</p>
<p>③ 이용자가 회사에 대하여 개인정보 오류 등에 대한 정정 또는 삭제를 요구한 경우에는 회사의 정정 또는 삭제가 완료될 때까지 당해 개인정보를 이용 또는 제공하지 않습니다.</p>
<p>④ 이용자는 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」, 「개인정보 보호법」 등 관계 법령을 위반하여 회사가 처리하고 있는 이용자 본인 또는 타인의 개인정보, 사생활을 침해하여서는 안 됩니다.</p>
<p>⑤ 회사가 직접 수집·처리하는 회원 개인정보에 대한 열람, 정정, 삭제, 처리정지, 동의 철회 등 권리행사는 회사에 직접 할 수 있습니다.</p>
<p>⑥ 학교 또는 수행기관으로부터 위탁받아 처리하는 학생, 교직원 또는 기타 처치 대상자의 개인정보에 대한 열람, 정정, 삭제, 처리정지 등 권리행사는 원칙적으로 해당 학교 또는 수행기관을 통하여 이루어지며, 회사는 수탁자로서 이에 필요한 범위 내에서 협조합니다.</p>

<h2>제 10 조 [개인정보의 안전성 확보조치]</h2>
<p>회사는 개인정보의 안전성 확보를 위하여 다음 각 호와 같은 조치를 취하고 있습니다.</p>
<p class="indent">1. 관리적 조치: 내부관리계획의 수립 및 시행, 정기적 직원 교육 등</p>
<p class="indent">2. 기술적 조치: 개인정보처리시스템 등의 접근권한 관리, 비밀번호의 암호화, 보안프로그램의 설치 등</p>
<p class="indent">3. 물리적 조치: 허가 받지 않은 자의 서버 접근통제 등</p>
<p class="indent">4. 학생 개인정보 보호를 위한 추가 조치</p>
<p class="indent2">– 학생 개인정보 접근 권한의 최소화 및 업무 담당자 한정</p>
<p class="indent2">– 접근기록의 보관 및 정기적 점검</p>
<p class="indent2">– 건강정보 등 민감정보의 암호화 저장</p>

<h2>제 11 조 [개인정보 보호책임자 및 담당부서]</h2>
<p>회사는 개인정보 처리에 관한 업무에 관해 총괄 책임을 지고 개인정보 처리와 관련한 이용자의 개인정보 열람청구 접수·처리, 불만처리, 그 밖의 기타 문의·답변 등을 위해 다음 각 호와 같이 개인정보 보호책임자 및 담당부서를 지정하고 있습니다. 이용자는 회사의 서비스를 이용하면서 발생하는 모든 개인정보보호 관련 문의, 불만, 조언이나 기타 사항에 대해 개인정보 보호책임자 및 담당부서로 연락하시기 바랍니다. 회사는 이용자의 목소리에 귀 기울이고 신속하고 충분한 답변을 드릴 수 있도록 최선을 다하겠습니다.</p>
<div class="notice">
<p><strong>개인정보 보호책임자 및 담당부서</strong></p>
<p>이름: 김창욱</p>
<p>부서명: 기획팀</p>
<p>직책: CEO(대표)</p>
<p>전화: 010-3209-8919</p>
<p>전자메일: ${COMPANY_EMAIL}</p>
</div>

<h2>제 12 조 [개인정보 처리 업무의 위탁]</h2>
<p>① 회사는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다. 위탁계약 체결 시 「개인정보 보호법」 제26조에 따라 위탁업무 수행목적 외 개인정보 처리 금지, 안전성 확보 조치, 재위탁 제한, 수탁자에 대한 관리·감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.</p>
<p>② 회사의 개인정보 처리 업무를 위탁받은 수탁업체 및 재수탁업체 현황은 다음과 같습니다.</p>
<table>
<thead>
<tr><th>구분</th><th>업체명</th><th>업무 내용</th><th>개인정보 보유 및 이용기간</th></tr>
</thead>
<tbody>
<tr><td>수탁자</td><td>(주)브레인다이브</td><td>보건건강일지 시스템 운영 및 관리</td><td>회원 탈퇴 시 또는 위탁 계약 종료 시까지</td></tr>
<tr><td>재수탁자</td><td>네이버클라우드(주)</td><td>클라우드 인프라 제공 및 데이터 보관</td><td>위탁 계약 종료 시 또는 서비스 해지 시까지</td></tr>
</tbody>
</table>
<p>③ 회사는 효율적인 업무 수행을 위해 수탁자가 제3자에게 업무를 재위탁하는 경우, 회사의 사전 승인을 받도록 관리하고 있습니다. 재수탁 업체가 변경되거나 추가될 경우 본 개인정보 처리방침을 통해 지체 없이 공개하겠습니다.</p>

<h2>제 13 조 [권익침해 구제 방법]</h2>
<p>이용자는 개인정보 침해로 인한 구제를 받기 위하여 개인정보분쟁조정위원회, 한국인터넷진흥원, 개인정보침해신고센터 등에 분쟁해결이나 상담 등을 신청할 수 있습니다. 이 밖에 기타 개인정보 침해의 신고, 상담에 대하여는 아래 기관에 문의하셔서 도움을 받으실 수 있습니다.</p>
<p class="indent">– 개인정보침해신고센터: (국번 없이) 118 (privacy.kisa.or.kr)</p>
<p class="indent">– 개인정보분쟁조정위원회: (국번 없이) 1833-6972 (www.kopico.go.kr)</p>
<p class="indent">– 대검찰청: (국번 없이) 1301 (www.spo.go.kr)</p>
<p class="indent">– 경찰청: (국번 없이) 182 (cyberbureau.police.go.kr)</p>

<h2>제 14 조 [개인정보 처리방침의 변경]</h2>
<p>① 회사는 법률이나 서비스의 변경사항을 반영하기 위한 목적 등으로 개인정보 처리방침을 수정할 수 있습니다. 개인정보 처리방침이 변경되는 경우 회사는 변경사항을 게시하며, 변경된 개인정보 처리방침은 게시한 날로부터 7일 후부터 효력이 발생합니다. 단, 처리하는 개인정보의 항목, 처리목적의 변경 등과 같이 이용자의 권리에 중대한 변경이 발생할 때에는 최소 30일 전에 미리 알려드리겠습니다.</p>

<div class="footer">
<p>&lt;부칙&gt; 본 개인정보 처리방침은 2026년 3월 7일부터 적용됩니다.</p>
<p>시행일자: 2026년 3월 7일</p>
</div>
`;
